(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxSitePrinterQueues(
    $location, $window
  ) {
    return {
      restrict: 'EA',
      scope: {
        printer: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/sitePrinterQueues/sitePrinterQueues.template.html',
      link: function(scope) {

        (function() {
          checkGroupStatus();
        })();

        function checkGroupStatus () {
          angular.forEach(scope.printer._embedded.queues, function(queue) {
            queue.groupsEnabled = false;
            if (queue._links['px:group'] || queue._links['px:autoInstallGroup'] || queue._links['px:defaultForGroup']) {
              queue.groupsEnabled = true;
            }
          })
        }
        
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;  
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;  
          if (showTip) { 
            position.startX = position.startX - offsetLeft; 
            position.startY = position.startY - offsetTop; 
            switch(tooltipScope) {
              case 'queue':
                queueTooltip(position, context);
              break;
              case 'settingTooltip':
                settingTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function queueTooltip (position, queue) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Queue',
            type: 'queueDetails',
            queue: queue,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        function settingTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            type: 'statement',
            title: title,
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }
        
        scope.gotoQueueProperties = function (queue) {
          var printerId = scope.printer._links.self.href.split('/').pop();
          var queueId = queue._links.self.href.split('/').pop();
          $window.open(`/admin/#/printQueueProperties/${printerId}/${queueId}`);
        }

        scope.gotoPrinterQueuesList = function () {
          var printerId = scope.printer._links.self.href.split('/').pop();
          window.open(`/admin/#/printerProperties/${printerId}?printerSection=queues`);
        }

      }
    };
  }

  pxSitePrinterQueues.$inject = ['$location', '$window'];

  angular
    .module('printix-admin')
    .directive('pxSitePrinterQueues', pxSitePrinterQueues);

})();
